import { Component, Input, OnInit } from '@angular/core';
import { AccountService } from 'src/app/account/services/account.service';
import { OrderService } from 'src/app/order/services/order.service';
import { JobService } from 'src/app/timeline-skip/services/job.service';
import { VehicleService } from 'src/app/vehicle/services/vehicle.service';
import { DriverService } from 'src/app/driver/services/driver.service';
import { DashboardStateServiceService } from '../../services/dashboard-state-service.service';
import { catchError, take } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
    selector: 'app-accounts-orders-stats-row',
    templateUrl: './accounts-orders-stats-row.component.html',
    styleUrls: ['./accounts-orders-stats-row.component.scss'],
    standalone: false
})
export class AccountsOrdersStatsRowComponent implements OnInit {
  @Input() startDate: string;
  @Input() endDate: string;

  stats = [
    { icon: 'fa-user-friends', label: 'Total Accounts', value: null, accent: '#006498' },
    { icon: 'fa-truck-loading', label: 'Jobs in Range', value: null, accent: '#f99420' },
    { icon: 'fa-clock', label: 'Orders Pending', value: null, accent: '#1a1a1a' },
    { icon: 'fa-check-circle', label: 'Orders Accepted', value: null, accent: '#5AA454' },
    { icon: 'fa-truck', label: 'Active Vehicles', value: null, accent: '#006498' },
    { icon: 'fa-id-card', label: 'Total Drivers', value: null, accent: '#f99420' },
  ];

  constructor(
    private accountService: AccountService,
    private orderService: OrderService,
    private jobService: JobService,
    private vehicleService: VehicleService,
    private driverService: DriverService,
    private dashboardStateService: DashboardStateServiceService
  ) { }

  ngOnInit(): void {
    // Not date-scoped, current totals only fetched once.
    this.accountService.getAllAccounts()
      .pipe(take(1))
      .pipe(catchError(() => of([])))
      .subscribe((accounts: any) => {
        this.stats[0].value = accounts.length;
      });

    this.vehicleService.getAllVehicles()
      .pipe(take(1))
      .pipe(catchError(() => of([])))
      .subscribe((vehicles) => {
        this.stats[4].value = vehicles.filter((v) => v.active).length as any;
      });

    this.driverService.countDrivers()
      .pipe(take(1))
      .pipe(catchError(() => of([])))
      .subscribe((drivers: any) => {
        this.stats[5].value = drivers.length;
      });

    this.dashboardStateService.$datesChanged.subscribe(() => {
      this.loadDateScopedStats();
    });

    this.loadDateScopedStats();
  }

  loadDateScopedStats(): void {
    this.jobService.getJobsByDateRange(this.startDate, this.endDate)
      .pipe(take(1))
      .pipe(catchError(() => of([])))
      .subscribe((jobs) => {
        this.stats[1].value = jobs.length as any;
      });

    this.orderService.getOrderCountByStatus('Pending', this.startDate, this.endDate)
      .pipe(take(1))
      .pipe(catchError(() => of(null)))
      .subscribe((count) => {
        this.stats[2].value = count;
      });

    this.orderService.getOrderCountByStatus('Accepted', this.startDate, this.endDate)
      .pipe(take(1))
      .pipe(catchError(() => of(null)))
      .subscribe((count) => {
        this.stats[3].value = count;
      });
  }

}
